export default __webpack_public_path__ + "static/media/nft3.a07fdb91.jpeg";